import SessionRepository from './session.repository'
import PlayerRepository from './player.repository'

export default {
  session: SessionRepository,
  player: PlayerRepository,
}
